/* eslint-disable react/prop-types */
import MyImage from '@shared/components/myImage'
import styles from './style.module.scss'
import React, { useState } from 'react'
import wplIcon from '@assets/images/wpl/wplLogo.svg'
import wplTitle from '@assets/images/wpl/capHolder.png'
import purple from '@assets/images/wpl/purple.png'
import orange from '@assets/images/wpl/orange.png'
import { getImgURL } from '@shared-submodule/utils'
import CustomLink from '@shared/components/customLink'
import useWindowSize from '@shared/hooks/windowSize'
import Image from 'next/future/image'

function WPLCaps({ purpleOrangeCap, isMobile = false }) {
  const [width] = useWindowSize()
  const orangeCapData = purpleOrangeCap?.data?.listSeriesTopPlayers?.find(d => d?.eFullType === 'batting_most_runs')
  const purpleCapData = purpleOrangeCap?.data?.listSeriesTopPlayers?.find(d => d?.eFullType === 'bowling_top_wicket_takers')
  const [cap, setCap] = useState('purple')
  return (
    <div className={styles.leaguePointsTable}>
      <div className={`d-flex align-items-center ${styles.tableBanner}`}>
        <div className="d-flex gap-2 align-items-center">
          <MyImage className={styles.logo} src={wplIcon} />
          <MyImage className={styles.logo} src={wplTitle} />
        </div>
      </div>
      <div className={styles.tableCntr}>
        <div className={styles.filterContainer}>
          {['orange', 'purple']?.map((d, i) => {
            return (
              <button key={i} onClick={() => setCap(d)} className={`${styles.filterButton} ${cap === d ? styles.activeFilter : ''}`}>
                {d.charAt(0).toUpperCase() + d.slice(1)}
              </button>
            )
          })}
        </div>
        {width > 767 ? (<div className={styles.capAlign}>
        <MyImage src={cap === 'purple' ? purple : orange} height={98} width={125} />
        {cap === 'orange' && purpleOrangeCap?.data?.listSeriesTopPlayers?.length > 0 && (
          <>
            <h4 className="font-bold">{orangeCapData?.nRuns} Runs</h4>
            <MyImage className={styles.player} src={getImgURL(orangeCapData?.oPlayer?.oImg?.sUrl)} height={60} width={60} />
            <CustomLink href={`/${orangeCapData?.oPlayer?.oSeo?.sSlug}`}>
              <a>
                <h5 className="mt-2 mb-1">{orangeCapData?.oPlayer?.sFullName}</h5>
              </a>
            </CustomLink>
            <p className="mx-4 text-center text-small text-secondary">{orangeCapData?.oTeam?.sTitle}</p>
          </>
        )}
        {cap === 'purple' && purpleOrangeCap?.data?.listSeriesTopPlayers?.length > 0 && (
          <>
            <h4 className="font-bold">{purpleCapData?.nWickets} Wickets</h4>
            <MyImage className={styles.player} src={getImgURL(purpleCapData?.oPlayer?.oImg?.sUrl)} height={60} width={60} />
            <CustomLink href={`/${purpleCapData?.oPlayer?.oSeo?.sSlug}`}>
              <a>
                <h5 className="mt-2 mb-1">{purpleCapData?.oPlayer?.sFullName}</h5>
              </a>
            </CustomLink>
            <p className="mx-4 text-center text-small text-secondary">{purpleCapData?.oTeam?.sTitle}</p>
          </>
        )}
        </div>) : (
          <div className='d-flex flex-row gap-3'>
            <div className='d-flex flex-column'>
                <MyImage src={cap === 'purple' ? purple : orange} height={98} width={125} />
                <h4 className="font-bold text-center">{cap === 'purple' ? `${purpleCapData?.nWickets} Wickets` : `${orangeCapData?.nRuns} Runs`}</h4>
            </div>
            <div className='d-flex flex-column align-items-center'>
                <Image unoptimized={true} className={styles.player} src={cap === 'purple' ? getImgURL(purpleCapData?.oPlayer?.oImg?.sUrl) : getImgURL(orangeCapData?.oPlayer?.oImg?.sUrl)} height={60} width={60} layout='raw'/>
                {!isMobile ? <CustomLink href={cap === 'purple' ? `/${purpleCapData?.oPlayer?.oSeo?.sSlug}` : `/${orangeCapData?.oPlayer?.oSeo?.sSlug}`}>
                  <a>
                    <h5 className="mt-2 mb-1">{cap === 'purple' ? purpleCapData?.oPlayer?.sFullName : orangeCapData?.oPlayer?.sFullName}</h5>
                  </a>
                </CustomLink> : <h5 className="mt-2 mb-1">{cap === 'purple' ? purpleCapData?.oPlayer?.sFullName : orangeCapData?.oPlayer?.sFullName}</h5>
                }
                <p className="mx-4 text-center text-small text-secondary">{cap === 'purple' ? purpleCapData?.oTeam?.sTitle : orangeCapData?.oTeam?.sTitle}</p>
            </div>
          </div>
        )}
        {purpleOrangeCap?.data?.listSeriesTopPlayers?.length === 0 && (
          <>
            <h5 className="text-center mb-2 mt-5">The tournament kicks off tomorrow!</h5>
            <p className="mx-4 text-center text-small text-secondary"> Stay tuned for the Purple Cap and Orange Cap leaderboards</p>
          </>
        )}
      </div>
    </div>
  )
}

export default WPLCaps
